module.exports = __webpack_public_path__ + "assets/img/worldviewImg-783d6a20.png";